import { Component } from '@angular/core';

@Component({
    selector: 'app-notification-settings',
    template: '',
    standalone: true
})
export class NotificationSettingsComponent {

}
